module.exports = __webpack_public_path__ + "img/weddings_10_H.44bd5873.jpg";